/* eslint-disable sort-keys */
import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseBulletTokens = {
    BACKGROUND_COLOR: {
        default: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        accent: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        danger: CFTokens.COLOR.CHROMATIC_STRAWBERRY_DEFAULT,
        success: CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
        strong: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    },
    BORDER_COLOR: {
        default: CFTokens.COLOR.BORDER_DEFAULT,
        accent: CFTokens.COLOR.CHROMATIC_PRIMARY_MID_TONE,
        danger: CFTokens.COLOR.TRANSPARENT,
        success: CFTokens.COLOR.TRANSPARENT,
        strong: CFTokens.COLOR.TRANSPARENT,
    },
    ICON_SIZE: {
        xs: 'xxs',
        sm: 'xs',
        md: 'sm',
        lg: 'md',
        xl: 'md',
    },
    SIZE: {
        xs: 24,
        sm: 32,
        md: 40,
        lg: 48,
        xl: 54,
    },
    TEXT_COLOR: {
        default: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        accent: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        danger: CFTokens.COLOR.CHROMATIC_STRAWBERRY_SUBTLE,
        success: CFTokens.COLOR.CHROMATIC_FOREST_SUBTLE,
        strong: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
    },
    TYPE_SPEC: {
        xs: 'DBoldAuto',
        sm: 'EBoldAuto',
        md: 'FBoldAuto',
        lg: 'GBoldAuto',
        xl: 'HBoldAuto',
    },
};
//
// Helpers
//
export const CFBaseBulletHelpers = {
    colors: ({ $color = 'default' }) => {
        return css `
      border: 1px solid
        ${CFBaseBulletTokens.BORDER_COLOR[$color]};
      background-color: ${CFBaseBulletTokens.BACKGROUND_COLOR[$color]};
      color: ${CFBaseBulletTokens.TEXT_COLOR[$color]};
    `;
    },
    size: ({ $size }) => {
        const size = CFBaseBulletTokens.SIZE[$size];
        return css `
      width: ${size}px;
      height: ${size}px;
    `;
    },
};
export const CFBaseBulletUtils = {
    getIconSize: (size) => CFBaseBulletTokens.ICON_SIZE[size],
    getTextColor: (color) => CFBaseBulletTokens.TEXT_COLOR[color],
    getTypeScale: (size) => CFBaseBulletTokens.TYPE_SPEC[size],
};
//
// Element Styles
//
export const CFBaseBulletStyles = {
    Root: css `
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    text-align: center;
    ${CFBaseBulletHelpers.colors};
    ${CFBaseBulletHelpers.size};
  `,
};
